import { render, staticRenderFns } from "./SendMessageTemplateRegister.vue?vue&type=template&id=bc9fef3c&scoped=true&lang=pug"
import script from "./SendMessageTemplateRegister.vue?vue&type=script&lang=ts"
export * from "./SendMessageTemplateRegister.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTemplateRegister.vue?vue&type=style&index=0&id=bc9fef3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9fef3c",
  null
  
)

export default component.exports